import dynamic from "next/dynamic";

const phone = dynamic(() => import("@/public/icons/phone"));
const vodafone = dynamic(() => import("@/public/icons/vodafon"));
const kiyvstar = dynamic(() => import("@/public/icons/kyivstar"));
const lifecell = dynamic(() => import("@/public/icons/lifecell"));
const close = dynamic(() => import("@/public/icons/close"));
const viber = dynamic(() => import("@/public/icons/viber"));
const letter = dynamic(() => import("@/public/icons/letter"));
const arrowDown = dynamic(() => import("@/public/icons/arrow-down"));
const arrowLeft = dynamic(() => import("@/public/icons/arrow-left"));
const arrowRight = dynamic(() => import("@/public/icons/arrow-right"));
const questionCircle = dynamic(() => import("@/public/icons/question-circle"));
const umbrella = dynamic(() => import("@/public/icons/umbrella"));
const pdf = dynamic(() => import("@/public/icons/pdf"));
const check = dynamic(() => import("@/public/icons/check"));
const uaAutoNumberAddon = dynamic(() => import("@/public/icons/ua-auto-number-addon"));
const pencil = dynamic(() => import("@/public/icons/pencil"));
const minus = dynamic(() => import("@/public/icons/minus"));
const plus = dynamic(() => import("@/public/icons/plus"));
const teczka = dynamic(() => import("@/public/icons/teczka"));
const globEuropa = dynamic(() => import("@/public/icons/glob_europa"));
const biret = dynamic(() => import("@/public/icons/biret"));
const globAfryka = dynamic(() => import("@/public/icons/glob_afryka"));
const globAmeryka = dynamic(() => import("@/public/icons/glob_ameryka"));
const windsurfing = dynamic(() => import("@/public/icons/windsurfing"));
const puchar = dynamic(() => import("@/public/icons/puchar"));
const trailer = dynamic(() => import("@/public/icons/trailer"));
const bus = dynamic(() => import("@/public/icons/bus"));
const motorcycle = dynamic(() => import("@/public/icons/motorcycle"));
const car = dynamic(() => import("@/public/icons/car"));
const truck = dynamic(() => import("@/public/icons/truck"));
const bigTruck = dynamic(() => import("@/public/icons/big-truck"));
const minivan = dynamic(() => import("@/public/icons/minivan"));
const plane = dynamic(() => import("@/public/icons/plane"));
const house = dynamic(() => import("@/public/icons/house"));
const uaFlag = dynamic(() => import("@/public/icons/uaFlag"));
const logo_facebook = dynamic(() => import("@/public/icons/logo_facebook"));
const logo_youtube = dynamic(() => import("@/public/icons/logo_youtube"));
const logo_instagram = dynamic(() => import("@/public/icons/logo_instagram"));
const circleCheckMedium = dynamic(() => import("@/public/icons/CircleCheckMedium"));
const info = dynamic(() => import("@/public/icons/info"));
const skisPoles = dynamic(() => import("@/public/icons/skis_poles"));

export const IconMap = {
    phone,
    vodafone,
    kiyvstar,
    lifecell,
    close,
    viber,
    letter,
    arrowDown,
    questionCircle,
    umbrella,
    pdf,
    check,
    arrowLeft,
    arrowRight,
    uaAutoNumberAddon,
    pencil,
    minus,
    plus,
    teczka,
    globEuropa,
    biret,
    globAfryka,
    globAmeryka,
    windsurfing,
    puchar,
    trailer,
    bus,
    motorcycle,
    car,
    truck,
    bigTruck,
    minivan,
    plane,
    house,
    uaFlag,
    facebook: logo_facebook,
    youtube: logo_youtube,
    instagram: logo_instagram,
    circleCheckMedium,
    info,
    skisPoles
};
